// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2931":"bd69a62542009a10","7001":"47574005c4d9a48a"}[chunkId] + ".js";
};